<mat-form-field
  disabled
  class="c-input"
  [ngClass]="{'remove-subtext': !hasError && !hint && !uploading, readonly: readonly}"
  appearance="outline"
  floatLabel="always"
  [subscriptSizing]="subscriptSizing"
>
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <input
    *ngIf="nameControl"
    matInput
    [formControl]="nameControl"
    [placeholder]="types"
    readonly
    (click)="selectFile()"
  />
  <mat-hint *ngIf="uploading">{{ 'file-edit.uploading' | translate }}</mat-hint>
  <mat-hint *ngIf="!uploading" class="hint" align="end">{{ hint }} </mat-hint>
  <mat-error *ngIf="fileUploadFailed">
    <ax-icon class="icon" name="alert-circle"></ax-icon>
    {{ 'file-edit.upload-failed' | translate }}
  </mat-error>
  <mat-error *ngIf="fileTypeError && !fileUploadFailed">
    <ax-icon class="icon" name="alert-circle"></ax-icon>
    {{ 'file-edit.error.incorrect-file-type' | translate: {types: fileTypeError.expectedTypes} }}
  </mat-error>
  <mat-error *ngIf="fileSizeError && !fileUploadFailed && !fileTypeError">
    <ax-icon class="icon" name="alert-circle"></ax-icon>
    {{
      ('file-edit.error.max-file-size' | translate) +
        ' ' +
        toByteNotation(fileSizeError.max) +
        ' (' +
        toByteNotation(fileSizeError.size) +
        ')'
    }}
  </mat-error>
  <mat-error *ngIf="requiredError && !fileSizeError && !fileUploadFailed && !fileTypeError">
    {{ 'property.validation.required' | translate: {propertyType: label} }}
  </mat-error>
  <ax-image-preview-button
    *ngIf="preview && !empty"
    class="preview"
    matSuffix
    [source]="demo ? demoUrl : (source$ | async)"
    [name]="nameControl?.value"
  ></ax-image-preview-button>
  @if (!readonly && nameControl?.enabled && nameControl?.value) {
    <button
      matSuffix
      axButton
      icon-button
      type="button"
      (click)="clearValue($event)"
      [ariaLabel]="'label.clear' | translate"
    >
      <ax-icon class="icon" name="close"></ax-icon>
    </button>
  }
</mat-form-field>

@if (!readonly) {
  <button
    class="clip"
    mat-mini-fab
    (click)="selectFile()"
    type="button"
    [ariaLabel]="'label.upload' | translate"
    [disabled]="uploading || nameControl?.disabled"
  >
    <ax-icon class="icon paperclip" name="paperclip"></ax-icon>
  </button>
}

<input
  hidden
  name="file"
  type="file"
  (change)="fileSelected($event)"
  [attr.accept]="accept"
  #fileSelect
/>
